import React from 'react';
import moment from 'moment';

import { Typography, TypographyProps } from '@mui/material';

interface DateDisplayProps extends Omit<TypographyProps, 'children'> {
    date: Date | string;
    prefix?: string;
    format?: string;
}

const DateDisplay: React.FC<DateDisplayProps> = ({
    date,
    prefix = '',
    format = 'Do MMM YYYY hh:mm A',
    ...typographyProps
}) => {

    const formattedDate = moment(date).format(format);

    return (
        <Typography {...typographyProps}>
            {prefix} {formattedDate}
        </Typography>
    );
};

export default DateDisplay